import {
  TransactionDoc,
  TransactionWhole,
} from 'lib/interfaces/database/transaction';
import _ from 'lodash';
import { TransactionsService } from 'services/transactions';
import { create } from 'zustand';

interface State {
  data: TransactionWhole[];
}

interface Actions {
  // server will force investorID to be set if run by an investor
  readonly load: (force?: boolean) => void;
  readonly create: (v: Partial<TransactionDoc>) => Promise<boolean>;
  readonly update: (id: string, v: Partial<TransactionDoc>) => Promise<boolean>;
  readonly markDeleted: (id: string) => Promise<boolean>;
}

interface Store extends State, Actions {}

const useTransactionsStore = create<Store>((set, get) => {
  const service = TransactionsService.getInstance();

  return {
    data: [],

    load: async (force) => {
      if (!force && get().data.length > 0) {
        console.debug('Skipped unforced load');
        return;
      }

      const results = await service.search({});

      if (results) {
        set({ data: results });
      }
    },

    create: async (v) => {
      const record = await service.create(v);

      if (record) {
        const nextData = _.clone(get().data);
        nextData.push(record);

        set({ data: nextData });
      }

      return !!record;
    },

    update: async (id, v) => {
      const record = await service.update(id, v);

      if (record) {
        const nextData = get().data.map((d) =>
          d.id === record.id ? record : d
        );

        set({ data: nextData });
      }

      return !!record;
    },

    markDeleted: async (id) => {
      const record = await service.markDeleted(id);

      if (record?.deleted) {
        const nextData = get().data.filter((d) => d.id !== record.id);

        set({ data: nextData });
      }

      return !!record?.deleted;
    },
  };
});

export default useTransactionsStore;
